'use client';

import { useRef } from 'react';
import { nanoid } from 'nanoid/non-secure';

/**
 * React 18 `useId` polyfill for environments where it isn't available.
 */
const useId = () => {
    const uniqueId = useRef(`uid-${nanoid()}`);
    return uniqueId.current;
};

export default useId;
